import { ProductGoToActionBlock } from "./ProductGoToActionBlock";
import { AnalyzeAllBtn } from "../ui/buttons";

export const StartAnalyzeAllBlock = ({
  campaign_id,
}: {
  campaign_id: string;
}) => {
  return (
    <ProductGoToActionBlock
      title="Launch Buying Committee Discovery"
      texts={[
        "Analyze all listed accounts with contacts below, or use checkboxes to select the accounts to start with.",
        "Explore analytics and gap analysis for analyzed accounts.",
      ]}
      btn={<AnalyzeAllBtn campaign_id={campaign_id} />}
    />
  );
};
